export default __webpack_public_path__ + "static/media/notFoundPage_table.90afaae6.png";